@if (optionState$ | async; as optionState) {
  <span>{{ optionState.translationKey || optionState.value | translate }}&nbsp;({{ optionCount$ | async }})</span>
  <svg-icon data-test-id="chip-remove" class="cursor-pointer" src="chip-remove" preserveAspectRatio="none" [stretch]="true" (click)="resetFilterOption()">
  </svg-icon>
}
